import React from 'react';
import { APP_COLORS as C, APP_FONT as F } from '../tokens';

type Props = {
  userName?: string;
  onCustomize?: () => void;
  onPrivacy?: () => void;
};

function readFirstName(): string {
  try {
    const keys = ['first_name', 'user_name', 'full_name', 'name', 'userName', 'userFullName'];
    for (const k of keys) {
      const v = typeof window !== 'undefined' ? window.localStorage.getItem(k) : null;
      if (v && v.trim()) return v.trim().split(' ')[0];
    }
    const u = typeof window !== 'undefined' ? window.localStorage.getItem('user') : null;
    if (u) {
      try {
        const o = JSON.parse(u);
        const n = o && (o.first_name || o.firstName || o.full_name || o.name || o.user_name);
        if (n && String(n).trim()) return String(n).trim().split(' ')[0];
      } catch (e) {}
    }
  } catch (e) {}
  return '';
}

function greetingPrefix(): string {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
}

const Icon = ({ children }: { children: React.ReactNode }) => (
  <svg viewBox="0 0 24 24" width={16} height={16} fill="none" stroke="currentColor" strokeWidth={2.3} strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

const BTN_BASE: React.CSSProperties = {
  background: 'transparent',
  border: 0,
  color: C.ink,
  fontWeight: 600,
  fontSize: 13,
  padding: '8px 12px',
  borderRadius: 8,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 7,
  fontFamily: F.family,
};

export default function GreetingBar({ userName, onCustomize, onPrivacy }: Props) {
  const first = (userName && userName.split(' ')[0]) || readFirstName();
  const name = first ? ', ' + first : '';
  const [hovered, setHovered] = React.useState<string | null>(null);

  const bg = (k: string): React.CSSProperties =>
    hovered === k ? { background: C.pillHover } : {};

  return (
    <div style={{
      position: 'relative',
      display: 'block',
      padding: '6px 4px',
      marginBottom: 22,
      fontFamily: F.family,
      minHeight: 44,
    }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, margin: '4px 0 0', letterSpacing: '-0.015em', color: C.ink, textAlign: 'center', width: '100%' }}>
        {greetingPrefix()}{name}!
      </h1>

      <div style={{ position: 'absolute', right: 4, top: 6, display: 'flex', gap: 6, alignItems: 'center' }}>
        <button
          onMouseEnter={() => setHovered('customize')}
          onMouseLeave={() => setHovered(null)}
          onClick={onCustomize}
          style={{ ...BTN_BASE, ...bg('customize') }}
        >
          <Icon>
            <line x1="4" y1="7" x2="20" y2="7" />
            <line x1="4" y1="17" x2="20" y2="17" />
            <circle cx="9" cy="7" r="2.5" />
            <circle cx="15" cy="17" r="2.5" />
          </Icon>
          Customize
        </button>

        <button
          onMouseEnter={() => setHovered('privacy')}
          onMouseLeave={() => setHovered(null)}
          onClick={onPrivacy}
          style={{ ...BTN_BASE, ...bg('privacy') }}
        >
          <Icon>
            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
            <circle cx="12" cy="12" r="3" />
          </Icon>
          Privacy
        </button>

      </div>
    </div>
  );
}
